// src/enhancers/btHolidayCopy.js
(function () {
  function initOne(root) {
    if (!root || root.dataset.btHolidayCopyInited === "1") return;
    root.dataset.btHolidayCopyInited = "1";

    const toast = root.querySelector("#btCopyToast");
    const modal = root.querySelector("#btCopyModal");
    const modalInput = root.querySelector("#btCopyModalInput");
    const modalClose = root.querySelector("#btCopyModalCloseBtn");
    const modalSelect = root.querySelector("#btCopyModalSelectBtn");

    let toastTimer = null;

    function showToast(message) {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add("bt-toast--show");
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => toast.classList.remove("bt-toast--show"), 1500);
    }

    function openModal(code) {
      if (!modal || !modalInput) return;
      modalInput.value = code;
      modal.classList.add("bt-modal--show");
      setTimeout(() => {
        modalInput.focus();
        modalInput.select();
      }, 0);
    }

    function closeModal() {
      if (!modal) return;
      modal.classList.remove("bt-modal--show");
    }

    function fallbackCopy(code) {
      try {
        const ta = document.createElement("textarea");
        ta.value = code;
        ta.setAttribute("readonly", "");
        ta.style.position = "fixed";
        ta.style.left = "-9999px";
        ta.style.top = "0";
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        const ok = document.execCommand("copy");
        document.body.removeChild(ta);
        return ok;
      } catch (_) {
        return false;
      }
    }

    async function copyCode(codeRaw) {
      const code = String(codeRaw || "").trim();
      if (!code) {
        showToast("無法複製：找不到優惠碼");
        return;
      }

      try {
        if (
          navigator.clipboard &&
          typeof navigator.clipboard.writeText === "function" &&
          window.isSecureContext
        ) {
          await navigator.clipboard.writeText(code);
          showToast("已複製優惠碼：" + code);
          return;
        }
      } catch (_) {}

      const ok = fallbackCopy(code);
      if (ok) {
        showToast("已複製優惠碼：" + code);
        return;
      }

      showToast("自動複製受限，請改用手動複製");
      openModal(code);
    }

    // 你文章裡按鈕是用 data-copy，所以沿用同邏輯
    root.addEventListener("click", function (e) {
      const btn = e.target.closest("[data-copy]");
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      copyCode(btn.getAttribute("data-copy"));
    });

    if (modalClose) modalClose.addEventListener("click", closeModal);

    if (modalSelect && modalInput) {
      modalSelect.addEventListener("click", function () {
        modalInput.focus();
        modalInput.select();
      });
    }

    if (modal) {
      modal.addEventListener("click", function (e) {
        if (e.target === modal) closeModal();
      });
    }

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal && modal.classList.contains("bt-modal--show")) {
        e.preventDefault();
        closeModal();
      }
    });
  }

  function initAll() {
    // 你的文章 root 固定是這個 id
    const root = document.getElementById("bt-holiday-2025");
    if (root) initOne(root);
  }

  // 首次載入
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // 讓 SPA / 動態載入文章後可以手動再跑一次
  window.__btHolidayCopyInitAll = initAll;
})();
